"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useRef } from "react";
import type SwiperCore from "swiper";
import type { SectionPackage } from "@/lib/navigation";
import SectionPackageCard from "@/app/(main)/components/SectionPackageCard";

import "swiper/css";
import "swiper/css/navigation";

export default function SectionPackagesSlider({
  packages,
  sectionTitle,
  pageTitle,
}: {
  packages: SectionPackage[];
  sectionTitle?: string;
  pageTitle?: string;
}) {
  const swiperRef = useRef<SwiperCore | null>(null);

  if (packages.length === 0) return null;

  const heading = sectionTitle || "Exclusive Packages";

  return (
    <div className="slider-area">
      <div className="title-area text-center">
        {pageTitle && <span className="sub-title">{pageTitle}</span>}
        <h2 className="sec-title">{heading}</h2>
      </div>
      <Swiper
        className="th-slider has-shadow wrapper-py-0 slider-drag-wrap"
        modules={[Navigation]}
        loop={packages.length > 3}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        spaceBetween={15}
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 2 },
          1200: { slidesPerView: 3 },
        }}
      >
        {packages.map((pack) => (
          <SwiperSlide key={pack.id}>
            <SectionPackageCard pack={pack} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="icon-box mt-30 text-center">
        <button
          className="slider-arrow style6 default"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <Image
            src="/main/img/icon/right-arrow2.svg"
            alt="Previous"
            width={24}
            height={24}
          />
        </button>
        <button
          className="slider-arrow style6 default"
          onClick={() => swiperRef.current?.slideNext()}
        >
          <Image
            src="/main/img/icon/left-arrow2.svg"
            alt="Next"
            width={24}
            height={24}
          />
        </button>
      </div>
    </div>
  );
}
